import React from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import uuid from 'react-uuid';

const AlertMessage = ({
  searchParams,
  shopRequired = false,
  errorText,
  errors = [],
}) => {
  const { t } = useTranslation();
  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');
  const byCompany = searchParams.get('by_company');

  return (
    <>
      {errors.map((error, index) => (
        <React.Fragment key={uuid()}>
          <br />
          <Alert message={error} type='error' />
        </React.Fragment>
      ))}
      {!byPeriod && (
        <>
          <br />
          <Alert
            message={t('Periodo non può essere lasciato in bianco')}
            type='error'
          />
        </>
      )}
      {!byShoppingCenter && (
        <>
          <br />
          <Alert
            message={t('Outlet Village non può essere lasciato in bianco')}
            type='error'
          />
        </>
      )}
      {!byCompany && shopRequired && (
        <>
          <br />
          <Alert
            message={t('Insegna non può essere lasciato in bianco')}
            type='error'
          />
        </>
      )}
      {errorText && (
        <>
          <br />
          <Alert message={errorText} type='error' />
        </>
      )}
    </>
  );
};

export default AlertMessage;
